import React from "react";

const AdminUser = () => {
  return <div>user</div>;
};

export default AdminUser;
